import request from '@/utils/request'
const BASE_URL = '/StInDocLog'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  ProductList(data) {
    return request({
      url: BASE_URL + '/ProductList',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
   
    return request({
      url: BASE_URL + '/Delete',
      method: 'get',
      params: { id }
    })
  },
  examine(id) {
    return request({
      url: BASE_URL + '/Examine',
      method: 'get',
      params: { id }
    })
  },
  cancelExamine(id){
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  import: "/api" + BASE_URL + '/Import',
  reviewAll(data) {
    return request({
      url: BASE_URL + '/ReviewAll',
      method: 'post',
      data
    })
  },
  backAll(data) {
    return request({
      url: BASE_URL + '/BackAll',
      method: 'post',
      data
    })
  },
  synchronous(data) {
    return request({
      url: BASE_URL + '/Synchronous',
      method: 'post',
      data
    })
  },
  UpdateStatus(ids) {
    return request({
      url: BASE_URL + '/UpdateStatus',
      method: 'post',
      data: {ids}
    })
  }
}